import React from 'react';
import { Row } from 'react-bootstrap';
import { Selectize, Fieldset } from '~/components/FormControl';
import PropTypes from 'prop-types';
import { maxLimit } from '../BoonForm';

function HealthPoint({ negOptions, posOptions }) {
    return (
        <Fieldset
            className={'px-4'}
            fieldsetStyle={{ flexGrow: 1 }}
        >
            <Fieldset.Legend>HP:</Fieldset.Legend>
            <Row>
                <Selectize
                    name="addonMaxHpList"
                    sm={3}
                    options={[...negOptions, ...posOptions]}
                    maxLimit={maxLimit}
                />
                <Selectize
                    name="addonRegenHpList"
                    sm={3}
                    options={posOptions}
                    maxLimit={maxLimit}
                />
                <Selectize
                    name="opponentAddonMaxHpList"
                    isNegativeAllowed
                    sm={3}
                    options={[...negOptions, ...posOptions]}
                    maxLimit={maxLimit}
                />
                <Selectize
                    name="opponentAddonRegenHpList"
                    isNegativeAllowed
                    sm={3}
                    options={[...negOptions, ...posOptions]}
                    maxLimit={maxLimit}
                />
            </Row>
        </Fieldset>
    );
}

HealthPoint.propTypes = {
    negOptions: PropTypes.array.isRequired,
    posOptions: PropTypes.array.isRequired,
};
export default HealthPoint;
